import {Route} from "react-router-dom";
import {lazy} from "react";
import {settingsRoutes} from "@/routes/ProtectedRoutes/ControlPanelRoutes/settingsRoutes";
import {usersRoutes} from "@/routes/ProtectedRoutes/ControlPanelRoutes/usersRoutes";
import {partnersRoutes} from "@/routes/ProtectedRoutes/ControlPanelRoutes/partnersRoutes";

import UrlsConfig from "@/config/UrlsConfig";

const ControlPanel = lazy(() => import("@/pages/ControlPanel/ControlPanel"));

const urlsConfig = new UrlsConfig();

export function controlPanelRoutes() {
    return (
      <>
          <Route path={urlsConfig.controlPanel.to} element={<ControlPanel/>}/>

          {settingsRoutes()}
          {usersRoutes()}
          {partnersRoutes()}
      </>
    );
}
